import React from "react";

interface ImgCaptionProps {
  caption?: string;
}

const ImgCaption: React.FC<ImgCaptionProps> = ({ caption }) => {
  const captionText =
    caption !== undefined && caption.indexOf("translation=") !== -1
      ? caption.split("translation=")
      : caption;

  return (
    <>
      {Array.isArray(captionText) ? (
        <div className="centered">
          <p className="mb--80">{captionText[0]}</p>
          <p>{captionText[1]}</p>
        </div>
      ) : (
        <h1 className="centered">{caption}</h1>
      )}
    </>
  );
};

export default ImgCaption;
